module.exports = __webpack_public_path__ + "static/media/filedownload.f81ffb06.svg";